// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"130":"d1e2a0bafd8af072","169":"d4dae9f2484f873a","192":"d3ba1394cdafe923","469":"ffd91f38794a9080","571":"ed80f889c0682261","575":"04bbeb2b7d4000d0","631":"a3ee3b3a77f17838","749":"5070d33c4597832a","897":"367fbb7011464ec5"}[chunkId] + ".js";
};